import React from "react";
import { useEffect,useContext,useState } from "react";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { methods } from '../../Validation';
import axios from 'axios';



    

const Body = () => {
   const { t, i18n } = useTranslation();
    const { setLogin } = useContext(GlobalContext);
    const loader = document.getElementById("loder-tive");

       const [showThanks,setSetshowThanks] = useState(true);
       const [formData, setFormData] = useState({
           oldPassword: '',
           newPassword: '',
           confirmPassword: '',
   
         });
         const [back_end_error,setBack_end_error] = useState(null);
           let [formdata_valid_error,setFormDatavalid] = useState({//validName
                 oldPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Old_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:t('Old_password_does_not_match')}],required:true,error:false,errormsg:null
                 },
                 newPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('New_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Minimun 8 characters required"}],required:true,error:false,errormsg:null
                 },
                 confirmPassword: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Confirm_password_required')},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Minimun 8 characters required"},{keyname:'checkConfirmpassword',methods:'checkConfirmpassword',parmeters:[{password:formData.newPassword}],errormag:t('Password_does_not_match')}],con_index:2,required:true,error:false,errormsg:null},
         
               });
        
  
       const { siteName } = useContext(GlobalContext);
     
       let baseUrl = siteName.baseUrl;
       let webEndpoints = siteName.webEndpoints;
    

       const handleChange = (e) => {
            const { name, value } = e.target;
           
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
                    let add_confirmation = false;
                if ("con_index" in formdata_valid_error[name]) {
                    add_confirmation = true;
                }
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if(add_confirmation){
                           if(i == formdata_valid_error[name].con_index){
                         
                            formdata_valid_error[name].validtion[i].parmeters[0].password = formData.newPassword;
                           } 
                        }
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
           
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                   loader.classList.remove('d-none');
                  let value;
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                             let add_confirmation = false;
                                if ("con_index" in formdata_valid_error[name]) {
                                    add_confirmation = true;
                                }
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                               if(add_confirmation){
                           if(i == formdata_valid_error[name].con_index){
                         
                            formdata_valid_error[name].validtion[i].parmeters[0].password = formData.newPassword;
                           } 
                        }
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false;
                              loader.classList.add('d-none'); 
                             break;
                          }
                       }
          
                       if(validation){
                                     
                          console.log('Form submitted:', 'success');
                          console.log('Form submitted:', formData);
                          handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          console.log('Form submitted:', 'faild');
                          console.log('Form submitted:', formData);

                          
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                 console.log(formData);


            const response = await axios.post(baseUrl+webEndpoints+'change/password', formdata_submit,{
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });
          let data = response;
          
          /*call back data*/
        setFormData({
           oldPassword: '',
           newPassword: '',
           confirmPassword: '',
   
         });
      if(data.status){
        setSetshowThanks(false);
         loader.classList.add('d-none'); 
        setTimeout(() => {
         
            const logout_action = (setLogin) => {
             
          localStorage.removeItem('token');
          localStorage.removeItem('name');
          localStorage.removeItem('loginbefore');
          localStorage.removeItem('role');
           loader.classList.add('d-none');
          window.location.reload();
          window.location.href = '/';
        };
        logout_action()
        }, 1000);
        
      }
      //window.location.reload();
         
        } catch (error) {
          //setErrormsg(error.response.data.message);
           loader.classList.add('d-none'); 
          console.log(error.response.data);
          setBack_end_error(error.response.data.message);
          /*error call back*/
        }
      
    };

     
   ;

return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('reset_password')}</h3>
            </div>
            <div class="form-items-wrapper">
                {back_end_error !=null? <div class="error">{back_end_error}</div> : ''}
                <div class="form-intem form-item-full">
                    <label for="oldPassword">{t('temporary_password')}{formdata_valid_error.oldPassword.required? <span>*</span> : ''}</label>
                    <input type="password" onChange={handleChange} placeholder={t('temporary_password')}  name="oldPassword" id="oldPassword" />
                       {formdata_valid_error.oldPassword.error? <div className="error">{formdata_valid_error.oldPassword.errormsg}</div> : ''}
                </div>
                <div class="form-intem form-item-full">
                    <label for="newPassword">{t('new_password')}{formdata_valid_error.newPassword.required? <span>*</span> : ''}</label>
                    <input type="password" onChange={handleChange}  name="newPassword" id="newPassword" placeholder={t('new_password')} />
                     {formdata_valid_error.newPassword.error? <div className="error">{formdata_valid_error.newPassword.errormsg}</div> : ''}
                </div>
          
                <div class="form-intem form-item-full">
                    <label for="confirmPassword">{t("confirm_password")}{formdata_valid_error.confirmPassword.required? <span>*</span> : ''}</label>
                    <input type="password" onChange={handleChange}  name="confirmPassword" id="confirmPassword" placeholder={t("confirm_password")} />
                    {formdata_valid_error.confirmPassword.error? <div className="error">{formdata_valid_error.confirmPassword.errormsg}</div> : ''}
                </div>
                 
           
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                             {t('Password_changed_successfully')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;